import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from "../../icons";
const alignmentsMap = {
  LEFT: {
    type: "button",
    text: "AlignObject_Left_Tooltip",
    tooltip: "AlignObject_Left_Tooltip",
    commandKey: "LEFT",
    icon: AlignLeftIcon,
    dataHook: "blockAlignmentButton_alignLeft"
  },
  CENTER: {
    type: "button",
    text: "AlignObject_Center_Tooltip",
    tooltip: "AlignObject_Center_Tooltip",
    commandKey: "CENTER",
    icon: AlignCenterIcon,
    dataHook: "blockAlignmentButton_alignCenter"
  },
  RIGHT: {
    type: "button",
    text: "AlignObject_Right_Tooltip",
    tooltip: "AlignObject_Right_Tooltip",
    commandKey: "RIGHT",
    icon: AlignRightIcon,
    dataHook: "blockAlignmentButton_alignRight"
  },
  TEXT_WRAP: {
    type: "toggle",
    text: "TextwrapObject_ToggleButton",
    commandKey: "TEXT_WRAP",
    dataHook: "blockTextWrapToggleButton"
  },
  SEPARATOR: {
    type: "divider"
  }
};
const defaultAlignments = [
  alignmentsMap.LEFT,
  alignmentsMap.CENTER,
  alignmentsMap.RIGHT,
  alignmentsMap.SEPARATOR,
  alignmentsMap.TEXT_WRAP
];
export {
  alignmentsMap,
  defaultAlignments
};
//# sourceMappingURL=consts.js.map
